// Horizontal scroll hint overlay. Targets .js-scroll elements.
// Requires scroll-hint library (enqueued globally in common.php).
export function initScrollHint() {
  if (!document.querySelector('.js-scroll')) return;
  if (typeof ScrollHint === 'undefined') return;
  new ScrollHint('.js-scroll');
}
